module.exports = __webpack_public_path__ + "static/img/换电柜banner1.a2ca32a8.png";